import { Helmet } from "react-helmet"
import {
    Box,
    Divider,
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    Typography
} from "@mui/material"
import React, { useEffect, useMemo } from "react"
import { makeStyles } from "@mui/styles"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import cssVariables from "../../theme/cssVariables"
import * as Util from "../../services/global.service"

import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg"
import CustomCheckbox from "../../components/CustomCheckbox"

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    paperRoot: {
        paddingTop: "24px!important",
        paddingBottom: "24px!important",
        paddingLeft: "32px!important",
        paddingRight: "32px!important",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)!important",
        borderRadius: "10px!important",
    }
})

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
}

const StyledPaper = (props) => {
    const classes = useStyles();
    return (
        <Paper
            classes={{ root: classes.paperRoot }}
            {...props}
        >
            {props.children}
        </Paper>
    );
}

const ReceiveForm = (props) => {
    const { doPreview, data } = { ...props }
    const classes = useStyles()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const notificationState = useSelector((state) => state.notificationCenter)

    const [isFormChecked, setIsFormChecked] = React.useState(false)
    const [receiverText, setReceiverText] = React.useState("")
    const [isReceiverString, setIsReceiverString] = React.useState(false)

    const handleFormChecked = (val) => {
        setIsFormChecked(val)
    }

    const handlePreview = () => {
        doPreview("receive")
    }

    const setData = (data) => {
        if (data?.status === "active") {
            setIsFormChecked(true)
        } else if (data?.status === "inactive") {
            setIsFormChecked(false)
        }
        let tmpReceiverText = notificationState.pageCode && notificationState.pageCode !== "goal" ? "To Manager" : "To Employee"
        setReceiverText(tmpReceiverText)
    }

    // useEffect
    useEffect(() => {
        dispatch({
            type: "SET_DATA_RECEIVE_FORM",
            payload: {
                feature: "receive",
                status: isFormChecked ? "active" : "inactive"
            }
        })
    }, [isFormChecked])

    useEffect(() => {
        if (notificationState?.emailNotification) {
            let formData = [...notificationState.emailNotification].find(item => item.feature === "receive")
            if (typeof formData?.receiver === 'string') {
                setIsReceiverString(true)
            } else {
                setIsReceiverString(false)
            }
            if (formData) setData(formData)
        }
    }, [notificationState.emailNotification])
    // end useEffect

    return (
        <StyledPaper>
            <Grid container>
                <Grid item xs={6} display="flex" alignItems="center">
                    <CustomCheckbox checked={isFormChecked} onChange={() => handleFormChecked(!isFormChecked)} sx={{ pl: 0 }} />
                    <Typography fontSize={20} fontWeight={600}>{t("emailNotificationCenter.label.receiveForm")}</Typography>
                </Grid>
                <Grid item xs="auto" ml="auto" display="flex" alignItems="center">
                    <Box sx={{ display: "flex", alignItems: "center" }} onClick={() => handlePreview()}>
                        <EmailIcon />
                        <Typography sx={{ ml: "10px" }} color="#5DA196" fontWeight={500} className="clickable"><u>{t("emailNotificationCenter.label.previewEmail")}</u></Typography>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt="45px" mb="6px">
                <Grid item md={4} xs={12} display="flex" alignItems="flex-start" flexDirection="column">
                    <Typography fontSize={18} fontWeight={500}>{t("emailNotificationCenter.label.receiver")}</Typography>
                    <Typography fontSize={14} fontWeight={400} color="#AAAAAA" sx={{ maxWidth: "300px" }}>{t("emailNotificationCenter.label.receiverDesc")}</Typography>
                </Grid>
                <Grid item xs="auto" display="flex" alignItems="flex-start" >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {!isReceiverString ?

                            <RadioGroup
                                aria-labelledby="receive-radio-group"
                                defaultValue="1"
                                name="radio-buttons-group"
                            >
                                <FormControlLabel value="1" control={<Radio disabled={!isFormChecked} />} label={receiverText} />
                                <FormControlLabel value="responsible" control={<Radio disabled />} label="To Pending Step Responsible Person" />
                            </RadioGroup>
                            : <Typography fontSize={16} fontWeight={400}>{receiverText}</Typography>
                        }
                    </Box>
                </Grid>
            </Grid>
        </StyledPaper>
    )
}
export default ReceiveForm
